
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../components/Footer";
import ImageSlideshow from "../components/ImageSlideshow";
import ServicesGrid from "../components/home/ServicesGrid";
import FAQ from "../components/home/FAQ";
import LocationsSection from "../components/home/LocationsSection";

const criticalImages = [
  "/lovable-uploads/09a7994e-6009-4b4d-a075-777fa17101cb.png",
  "/lovable-uploads/0b469f3d-856f-46dd-bdbd-a72675f5f325.png",
  "/lovable-uploads/7c62dd0b-e539-4203-a60a-6bc7f311869f.png",
  "/lovable-uploads/1f2b1448-a2bd-458c-82f9-a73bb1c5edc8.png",
  "/lovable-uploads/be06cbde-d197-4393-8178-f69093d87d35.png",
];

const Index = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    criticalImages.forEach((src) => {
      const img = new Image();
      img.fetchPriority = "high";
      img.decoding = "async";
      img.src = src;
    });
    import('../pages/About.jsx');
    import('../pages/Services.jsx');
    import('../pages/Contact.jsx');
    import('../pages/Locations.jsx');
  }, []);

  const handleMapClick = (stateAbbr) => {
    alert(`Clicked on ${stateAbbr}`);
  };

  return (
    <div className="flex flex-col">
      <Helmet>
        <title>USA Traffic Control - Professional Traffic Control Services</title>
        <meta name="description" content="USA Traffic Control offers comprehensive traffic control services, certified flaggers, and equipment rentals across the Western United States." />
        <meta name="keywords" content="traffic control, professional flaggers, road safety, traffic management" />
        <link rel="canonical" href="https://usatrafficcontrol.com" />
        <meta property="og:title" content="USA Traffic Control - Home" />
        <meta property="og:description" content="Leading provider of traffic control services in the Western United States." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <section className="bg-white">
        <ImageSlideshow />
      </section>
      <ServicesGrid />
      {/* FAQ section */}
      <section className="bg-white">
        <FAQ />
      </section>
      {/* Locations section using the extracted component */}
      <LocationsSection onClickState={handleMapClick} />
      <Footer />
    </div>
  );
};

export default React.memo(Index);
